import { createSlice } from "@reduxjs/toolkit";
import { getProfileRequest } from "../../api/userService";

const userSlice = createSlice({
	name: "User",
	initialState: {
		token: null,
		country: null,
		language: "en",
		profile: {},
		showOddsInMatchCard: false,
		authenticated: false,
		authError: null,
		authPending: false,
	},
	reducers: {
		setToken(state, action) {
			state.token = action.payload;
		},
		setCountry(state, action) {
			state.country = action.payload;
		},
		setLanguage(state, action) {
			state.language = action.payload;
		},
		setUser(state, action) {
			state.profile = action.payload;
		},
		setShowOddsInMatchCard(state, action) {
			state.showOddsInMatchCard = action.payload;
		},
		setAuthenticated(state, action) {
			state.authenticated = action.payload;
		},
		setAuthError(state, action) {
			state.authError = action.payload;
		},
		setAuthPending(state, action) {
			state.authPending = action.payload;
		},
		resetAuthState(state) {
			state.authenticated = false;
			state.authError = null;
			state.authPending = false;
			state.profile = {};
		},
	},
});

export const { setToken, setCountry, setLanguage, setUser, setShowOddsInMatchCard, setAuthenticated, setAuthError, setAuthPending, resetAuthState } =
	userSlice.actions;

export const authenticateWithToken = (token, userCountry, userLanguage) => async (dispatch) => {
	try {
		dispatch(setAuthPending(true));
		dispatch(setAuthError(null));

		if (!!userCountry) {
			dispatch(setCountry(userCountry));
		}
		if (!!userLanguage) {
			dispatch(setLanguage(userLanguage));
		}

		dispatch(setToken(token));
	} catch (error) {
		dispatch(setAuthError(error.message || "Authentication failed"));
		dispatch(setAuthPending(false));
		console.error("Token authentication error:", error);
	}
};

export const getUserRequest = (fansUnitedSDK) => async (dispatch) => {
	try {
		const profileResponse = await getProfileRequest(fansUnitedSDK);

		if (!profileResponse) {
			throw new Error("Failed to get user profile");
		}

		dispatch(setUser(profileResponse));
		dispatch(setAuthenticated(true));
		dispatch(setAuthPending(false));
	} catch (error) {
		let errorMessage = "Failed to get user profile";

		// Check if it's a JWT token error
		if (
			error.message &&
			(error.message.includes("JWT") ||
				error.message.includes("token") ||
				error.message.includes("unauthorized") ||
				error.message.includes("401"))
		) {
			errorMessage = "Invalid JWT token is provided";
		}

		dispatch(setAuthError(errorMessage));
		dispatch(setAuthenticated(false));
		dispatch(setAuthPending(false));
		console.error("Authentication error:", error);
	}
};

export default userSlice.reducer;
